import React from 'react';
import { FaPlus, FaClock, FaTrash } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/opdateringer.css';

const Opdateringer = ({ formData, handleAddUpdate, handleUpdateDateChange, handleDeleteUpdate, handleUpdateChange }) => {
  return (
    <div className="form-section crm-updates">
      <div className="section-header">
        <div className="header-title">
          <span className="section-icon">📝</span>
          <div>
            <h3>Opdateringer</h3>
            <div className="section-description">
              Tilføj opdateringer og noter om kundens forløb
            </div>
          </div>
        </div>
      </div>

      <div className="crm-updates__content">
        <button 
          type="button" 
          className="crm-updates__add-btn"
          onClick={handleAddUpdate}
        >
          <FaPlus />
          <span>Ny opdatering</span>
        </button>

        <div className="crm-updates__list">
          {formData.updates.map(update => (
            <div key={update.id} className="crm-update-item">
              <div className="crm-update-item__left">
                <FaClock className="crm-update-item__clock-icon" />
                <DatePicker
                  selected={new Date(update.timestamp)}
                  onChange={(date) => handleUpdateDateChange(update.id, date)}
                  timeFormat="HH:mm"
                  dateFormat="dd/MM/yy HH:mm"
                  showTimeSelect
                  timeIntervals={15}
                  locale="da"
                  className="crm-update-item__date"
                />
              </div>
              <textarea
                value={update.text}
                onChange={(e) => handleUpdateChange(update.id, e.target.value)}
                placeholder="Skriv din opdatering her..."
                className="crm-update-item__input"
                rows="2"
              />
              <button
                className="crm-update-item__delete"
                onClick={() => handleDeleteUpdate(update.id)}
                title="Slet opdatering"
              >
                <FaTrash />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Opdateringer;
